export function roleLoadError(status: number | undefined) {
  if (status === 404) {
    return { title: 'Not found', message: 'Role not found.', retry: false }
  }
  return {
    title: 'Unable to load',
    message: 'Unable to load this role. Check your access and try again.',
    retry: true,
  }
}
